// extracted by mini-css-extract-plugin
export default {"text":"InfoPages_text__bnTMj","heading":"InfoPages_heading__Q-HhZ"};